import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { SeguridadService } from '../../services/seguridad.service';

@Component({
  selector: 'app-cabecera-ventana',
  templateUrl: './cabecera-ventana.component.html',
  styleUrls: ['./cabecera-ventana.component.scss']
})
export class CabeceraVentanaComponent implements OnInit {

    @Input() cargando: boolean = false;

    @Input() modulo: string;
    @Input() codigoRegistro: string;
    @Input() tipo: string = 'maestro' || 'transaccion';
    @Input() readonly: boolean = false;
    @Input() esNuevo: boolean = false;
    @Input() aprobado: boolean = false;
    @Input() anulado: boolean = false;
    @Input() activo: boolean = true;
    @Input() fImprimir: boolean = false;
    @Input() acciones: Record<string, any>[] = [];

    @Output() eVolver = new EventEmitter();
    @Output() eNuevo = new EventEmitter();
    @Output() eGuardar = new EventEmitter();
    @Output() eEliminar = new EventEmitter();
    @Output() eInactivar = new EventEmitter();
    @Output() eEditar = new EventEmitter();
    @Output() eAnular = new EventEmitter();
    @Output() eAprobar = new EventEmitter();
    @Output() eImprimir = new EventEmitter();

    pCrear: boolean = false;
    pEditar: boolean = false;
    pGuardar: boolean = false;
    pEliminar: boolean = false;
    pInactivar: boolean = false;
    pAnular: boolean = false;
    pAprobar: boolean = false;
    pImprimir: boolean = false;
    pRevertirInactivacion: boolean = false;
    pRevertirAnulacion: boolean = false;
    pRevertirAprobacion: boolean = false;


    constructor(
        private confirmationService: ConfirmationService,
        private seguridadService: SeguridadService
    ) {
    }
    
    ngOnInit(): void {
        this.checkPermisos();
    }

    async checkPermisos() {
        this.pCrear = await this.seguridadService.puedeCrear(this.modulo, this.codigoRegistro);
        this.pEditar = await this.seguridadService.puedeEditar(this.modulo, this.codigoRegistro);
        this.pGuardar = this.pEditar;
        this.pEliminar = await this.seguridadService.puedeEliminar(this.modulo, this.codigoRegistro);
        this.pInactivar = await this.seguridadService.puedeInactivar(this.modulo, this.codigoRegistro);
        this.pAnular = await this.seguridadService.puedeAnular(this.modulo, this.codigoRegistro);
        this.pAprobar = await this.seguridadService.puedeAprobar(this.modulo, this.codigoRegistro);
        this.pImprimir = await this.seguridadService.puedeImprimir(this.modulo, this.codigoRegistro);
        this.pRevertirInactivacion = await this.seguridadService.puedeRevertirInactivacion(this.modulo, this.codigoRegistro);
        this.pRevertirAnulacion = await this.seguridadService.puedeRevertirAnulacion(this.modulo, this.codigoRegistro);
        this.pRevertirAprobacion = await this.seguridadService.puedeRevertirAprobacion(this.modulo, this.codigoRegistro);
    }

    async volver() {
        this.eVolver.emit();
    }

    async nuevo() {
        await this.confirmar('Seguro/a que desea crear un nuevo registro?', 'Nuevo Registro', this.eNuevo);
    }

    async editar() {
        this.eEditar.emit();
    }

    async guardar() {
        await this.confirmar('Seguro/a que desea guardar los cambios?', 'Guardar Registro', this.eGuardar);
    }

    async eliminar() {
        await this.confirmar('Seguro/a que desea eliminar?', 'Eliminar Registro', this.eEliminar);
    }

    async inactivar() {
        await this.confirmar('Seguro/a que desea inactivar?', 'Inactivar Registro', this.eInactivar);
    }

    async anular() {
        await this.confirmar('Seguro/a que desea anular?', 'Anular Registro', this.eAnular);
    }

    async aprobar() {
        await this.confirmar('Seguro/a que desea aprobar?', 'Aprobar Transacción', this.eAprobar);
    }

    async imprimir() {
        this.eImprimir.emit();
        // await this.confirmar('Seguro/a que desea aprobar?', 'Aprobar Transacción', this.eAprobar);
    }

    async revertirAprobacion() {
        await this.confirmar('Seguro/a que desea revertir la aprobación?', 'Revertir Aprobación', this.eAprobar, true);
    }

    async revertirInactivacion() {
        await this.confirmar('Seguro/a que desea revertir la inactivación?', 'Revertir Inactivación', this.eInactivar, true);
    }

    async revertirAnulacion() {
        await this.confirmar('Seguro/a que desea revertir la anulación?', 'Revertir Anulación', this.eAnular, true);
    }

    async confirmar( message: string, header: string, eEmit: EventEmitter<any>, value: boolean = false ) {
        this.confirmationService.confirm({
            message,
            header,
            icon: 'pi pi-info-circle',
            acceptLabel: 'Si, estoy seguro/a',
            accept: () => {
                eEmit.emit(value);
            }
        });
    }

}
